import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import myConfigRoutes from './../route-component';
import config from './../config';
import common from './../common';
import { sortBy } from './../helper';
import { find } from 'lodash';
import trackEventsObj from './../constants/new-pageTrackEvents'
import achievements from './achievements';
import OutsideNotifier from './../OutsideNotifier';
import $ from 'jquery'


class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldMenuHamburgerOpen: false
    }
    this.gameMenuItems = [];
  }

  openGame = (gameMenuItem) => {
    common.customTracking("Menu - Level 2 - Access " + gameMenuItem.name, null, "navigation");
    window.open(
      '//' +
      window.location.host +
      '/' +
      config.CURRENT_LANGUAGE +
      '/' +
      gameMenuItem.api_name,
      '_self'
    );
  }

  handleResize = () => {
    var mq = window.matchMedia('(max-width: 960px)');
    if (!mq.matches && this.state.shouldMenuHamburgerOpen) {
      this.setState({
        shouldMenuHamburgerOpen: false,
      });
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    this.gameMenuItems = window.uefaGHComponent.getGames();
    let leaguesSubpaths = [
      '/leagues',
      '/league-leaderboard',
      '/league-settings',
      '/public-leaderboard',
      '/memberteam',
    ];
    if (window.pathName == window.menuPreviousPage) {
    } else {
      if (leaguesSubpaths.indexOf(window.pathName) > -1 && leaguesSubpaths.indexOf(window.menuPreviousPage) > -1) {

      } else {
        if (common.isMobile()) {
          if ($('.si-menu--bottom') && $('.si-menu--bottom').find('a.active').length) {
            let menuItemPosition = $('.si-menu--bottom').find('a.active').offset()
              .left;
            $('.si-menu__dual').animate(
              {
                scrollLeft: menuItemPosition - 5,
              },
              1000
            );
          }
        }
      }
      window.menuPreviousPage = window.pathName;
    }
  }

  toggleMenu = (event, boolean) => {
    event.stopPropagation();
    if (boolean) {
      common.customTracking("Sticky menu - Level 2 - Open menu", null, "navigation");
    } else {
      common.customTracking("Sticky menu - Level 2 - Close menu", null, "navigation");
    }
    this.setState({
      shouldMenuHamburgerOpen: boolean,
    });
  };

  goToGamingHub = () => {
    common.customTracking("Menu - Level 2 - Access " + "Gaming Hub", null, "navigation");
    window.open("//" + window.location.host, "_self")
  };

  goToPage = () => {
    common.customTracking("Menu - Level 2 - Access " + "Football Fantasy", null, "navigation");
    const COOKIE_GM = config.COOKIE_GM;
    let cookie = common.getCookie(COOKIE_GM);
    let cookieGM = common.parseCookie(cookie);
    if (cookie && cookieGM.HasTeam == 1) {
      return this.props.history.push('/manage-team');
    }
    if (!cookie) {
      return this.props.history.push('/');
    }
  }

  callTracking = (url, name) => {
    if (name == "prizes") {
      common.pageViewTracking(url, trackEventsObj[name]);
      window.open(url);
    } else if (name == "rules") {
      common.pageViewTracking(url, trackEventsObj[name]);
      window.open(url);
    } else {
      // nothing
      common.customTracking("Menu - Level 2 - Access " + name, null, "navigation");
    }


  }

  render() {
    const isManageTeam = common.isManageTeam();
    // const article_id = {
    //   rules: {
    //     en: "2396425",
    //     es: "2396430",
    //     fr: "2396426",
    //     de: "2396431",
    //     it: "2396427",
    //     pt: "2396428",
    //     ru: "2396429"
    //   },
    //   prizes: {
    //     en: "2568611",
    //     es: "2568628",
    //     fr: "2568649",
    //     de: "2568626",
    //     it: "2568675",
    //     pt: "2568630",
    //     ru: "2568625"
    //   }
    // };
    // const article_id = {
    //   rules: {
    //     en: "https://gaming.uefa.com/news/025f-0fd4b42cc0a7-74498b7df63b-1000/?mobileview={{boolean}}",
    //     es: "https://gaming.uefa.com/news/025f-0fe2d6e94ea3-2644ad1749e9-1000/?mobileview={{boolean}}",
    //     fr: "https://gaming.uefa.com/news/025f-0fe2c838af3e-4502c7b2ebe7-1000/?mobileview={{boolean}}",
    //     de: "https://gaming.uefa.com/news/025f-0fe2ca1e0a2f-e4e9f5bec283-1000/?mobileview={{boolean}}",
    //     it: "https://gaming.uefa.com/news/025f-0fe2cd8ec96b-59710a23c6d1-1000/?mobileview={{boolean}}",
    //     pt: "https://gaming.uefa.com/news/025f-0fe2c67b2f72-8149c027c1de-1000/?mobileview={{boolean}}",
    //     ru: "https://gaming.uefa.com/news/025f-0fe3444021c9-8c634ca32f0c-1000/?mobileview={{boolean}}"
    //   },
    //   prizes: {
    //     en: "https://gaming.uefa.com/news/025f-0fd4b51510e8-9a324b5573e1-1000/?mobileview={{boolean}}",
    //     es: "https://gaming.uefa.com/news/025f-0fe2de73d25e-35d8f543f7e3-1000/?mobileview={{boolean}}",
    //     fr: "https://gaming.uefa.com/news/025f-0fe2ca51cadc-a8a91b2ca27e-1000/?mobileview={{boolean}}",
    //     de: "https://gaming.uefa.com/news/025f-0fe443b1a2c9-e4287e6d748b-1000/?mobileview={{boolean}}",
    //     it: "https://gaming.uefa.com/news/025f-0fe2c7abea92-4ee2b96a59d3-1000/?mobileview={{boolean}}",
    //     pt: "https://gaming.uefa.com/news/025f-0fe2d5e3e19e-51dda3b9ff4f-1000/?mobileview={{boolean}}",
    //     ru: "https://gaming.uefa.com/news/025f-0fe3483fb828-9e9e5043c763-1000/?mobileview={{boolean}}"
    //   }
    // };
    const isLoggedIn = common.getGUID();
    let menus = myConfigRoutes.filter(route => {
      let { toShow, isAuthRequired, isTeamRequired, onlyWhenNoTeam, path } = route;
      if (path.indexOf('/leagues/') > -1) {
        isAuthRequired = true;
        isTeamRequired = true;
      }
      return (toShow && (isAuthRequired ? isLoggedIn : true) && (isTeamRequired ? isManageTeam : true) && (onlyWhenNoTeam ? !isManageTeam : true));
    });
    menus = sortBy(menus, 'order', 'ASC');
    const isActive = (menu) => {
      return (match, location) => {
        let path = location.pathname;
        let route = {};
        if (path === '/') {
          route = find(myConfigRoutes, route => {
            return route.group && route.group.indexOf('home') > -1
          });
        } else {
          path = location.pathname.split('/').filter(Boolean)[0];
          route = find(myConfigRoutes, route => route.path.indexOf('/' + path) > -1);
        }
        return route.group === menu.group;
      };
    };
    if (this.props.mobilePlayerListingOpen) return null;
    return (
      <div
        className={ `${
          this.props.hideHeader
            ? 'si-ucl--menu si-hide-header'
            : 'si-ucl--menu '
          } ${this.state.shouldMenuHamburgerOpen ? 'si-open' : ''}` }>
        <div className="si-container">
          <OutsideNotifier
            handler={ (e) => {
              this.toggleMenu(e, false);
            } }>
            <div
              className='si-menu--hamburger'
              onClick={ (e) => {
                this.toggleMenu(e, true);
              } }>
              <span className='si-menu__txt'>
                { this.props.trans.menu_text
                  ? this.props.trans.menu_text
                  : 'MENU' }
              </span>
              <span className='si-menu__bar' />
              <span
                className='icon-ucl-close'
                onClick={ (e) => {
                  this.toggleMenu(e, false);
                } }
              />
            </div>
          </OutsideNotifier>
          <div className='si-menu__dual'>
            <ul className='si-menu--top'>
              <li>
                <a
                  onClick={ () => {
                    this.goToGamingHub();
                  } }>
                  { this.props.trans.menu_gaming_hub
                    ? this.props.trans.menu_gaming_hub
                    : 'GAMING HUB' }
                </a>
              </li>
              <li>
                <a onClick={ () => {
                  this.goToPage();
                } }>
                  { this.props.trans.fantasyClassic
                    ? this.props.trans.fantasyClassic
                    : 'FANTASY FOOTBALL' }
                </a>
              </li>
            </ul>
            <ul className='si-menu--bottom'>
              { menus.map((menu, index) => {
                if (menu.group == 'eos') return null;
                const path =
                  menu.path.indexOf(':') > -1 ? menu.path_ : menu.path;

                return (
                  <li key={ index }>
                    { menu.isExternal ? (
                      <a
                        onClick={ () => {
                          // this.callTracking(
                          //   menu.url.replace(
                          //     '{{ARTICLE_ID}}',
                          //     article_id[menu.name][config.CURRENT_LANGUAGE]
                          //   ),
                          //   menu.name
                          // );
                          // this.callTracking(
                          //   menu.url.replace(
                          //     '{{boolean}}',
                          //     config.isMobile ? 'true' : 'false'
                          //   ),
                          //   menu.name
                          // );
                          this.callTracking(
                            config.article_id[menu.name][config.CURRENT_LANGUAGE].replace(
                              '{{boolean}}',
                              config.isMobile ? 'true' : 'false'
                            ),
                            menu.name
                          );
                          // window.open(
                          //   menu.url.replace(
                          //     '{{ARTICLE_ID}}',
                          //     article_id[menu.name][config.CURRENT_LANGUAGE]
                          //   )
                          // );
                        } }>
                        { this.props.trans[`menu_${menu.name}`] }
                      </a>
                    ) : (
                        <NavLink
                          exact
                          to={ path }
                          activeClassName={ 'active' }
                          isActive={ isActive(menu) }
                          onClick={ () => this.callTracking(path, menu.name) }>
                          <span>{ this.props.trans[`menu_${menu.name}`] }</span>
                        </NavLink>
                      ) }
                  </li>
                );
              }) }
              <li
                key={ 'achievementsTab' }
                onClick={ () =>
                  window.uefaGHComponent.openAchievements('uclfantasy')
                }>
                {/* <NavLink exact to={ '' } onClick={ () => window.uefaGHComponent.openAchievements("uclfantasy") }> */ }
                <a>
                  { ' ' }
                  <span>{ this.props.trans[`menu_${'achievements'}`] }</span>
                </a>

                {/* </NavLink> */ }
              </li>
            </ul>
            {
              this.gameMenuItems.length > 0 ? (
                <ul className='si-menu--bottom si-menu--gh'>
                  { this.gameMenuItems.map((gameMenuItem, index) => {
                    return (
                      <li key={ index }>
                        <a
                          className={
                            config.APP_NAME == gameMenuItem.api_name
                              ? 'active'
                              : gameMenuItem.status == 'coming_soon'
                                ? 'si-disabled'
                                : ''
                          }
                          onClick={ () => {
                            this.openGame(gameMenuItem);
                          } }>
                          <span>{ gameMenuItem.name }</span>
                        </a>
                      </li>
                    );
                  }) }
                </ul>
              ) : (
                  ''
                )
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    trans: state.appData.trans,
    userToken: state.authData.userToken,
    userProfile: state.authData.userProfile,
    mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
  };
};
export default withRouter(connect(mapStateToProps, null)(Menu));


// WEBPACK FOOTER //
// ./src/components/Menu.js